export const STYLE_EVENT_TYPE = {
  COMMENT: 'comment',
  MAIN_VERSION_SET: 'main_version_set',
  NEW_VERSION_ADDED: 'new_version_added',
  STATUS_CHANGED: 'status_changed'
}
